import { useEffect, useState } from 'react';
import { createGigsSkeleton } from '../createGigsSkeleton';
import { COLLECT_MENU_POSITIONS } from '../../../GigCards/ModernGigCards/Components/CollectWrapper/constants';

import utilStyles from '../../../GigCards/styles/utils.module.scss';

// `ssrCount` defaults to `lazyOffset` so callers that don't pass it keep the old behaviour, where one offset drove both.
export const useRenderableGigs = (gigs, loading, skeletonSize, lazyOffset, ssrCount = lazyOffset) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    // Falsy stays "no limit" on both knobs, exactly as the single `_offset` this replaced behaved.
    // `??` would turn an explicit 0 into "SSR nothing", which is why it isn't used here.
    const _eagerOffset = lazyOffset || gigs.length;
    const _ssrCount = ssrCount || gigs.length;

    const transformedGigs = gigs.map((gig, index) => ({ ...gig, lazyLoad: index >= _eagerOffset }));

    if (loading) {
        return createGigsSkeleton(skeletonSize);
    }

    if (!isClient) {
        return transformedGigs.slice(0, _ssrCount);
    }

    return transformedGigs;
};

export const setCarouselGigsData = (slides, props, onClearClick, gigTracker) => {
    const { layoutClass, isTouch, isLoading, getContainerRef, showTranslatedUGC, collectProps, excludedBadges } = props;

    return slides.map((gig, index) => ({
        ...gig,
        layoutClass,
        isTouch,
        isLoading,
        tracker: gigTracker,
        getContainerRef,
        clearClick: onClearClick,
        showTranslatedUGC,
        collectProps: {
            ...collectProps,
            popoverContainerClassName: utilStyles.zIndex9999,
            menuPosition: index === 0 ? COLLECT_MENU_POSITIONS.BOTTOM_LEFT : COLLECT_MENU_POSITIONS.BOTTOM_RIGHT,
        },
        excludedBadges,
    }));
};
